import { render, staticRenderFns } from "./viewCheckupGallery.vue?vue&type=template&id=d67dadc6"
import script from "./viewCheckupGallery.vue?vue&type=script&lang=js"
export * from "./viewCheckupGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports